import EntryActionTypes from '../constants/EntryActionTypes';

const fetchContentViewPlansInCurrentBoard = () => ({
  type: EntryActionTypes.CONTENT_VIEW_PLANS_IN_CURRENT_BOARD_FETCH,
});

const getOrCreateContentViewPlanInCurrentBoard = (year, month) => ({
  type: EntryActionTypes.CONTENT_VIEW_PLAN_IN_CURRENT_BOARD_GET_OR_CREATE,
  payload: {
    year,
    month,
  },
});

const updateContentViewPlan = (id, data) => ({
  type: EntryActionTypes.CONTENT_VIEW_PLAN_UPDATE,
  payload: {
    id,
    data,
  },
});

export default {
  fetchContentViewPlansInCurrentBoard,
  getOrCreateContentViewPlanInCurrentBoard,
  updateContentViewPlan,
};

